export const services = [
  {
    id: 1,
    title: "Construction Services",
    description: "Your one-stop solution for all construction needs. With a stellar reputation for quality and excellence, we offer a wide range of services to meet your construction goals.",
    icon: "building",
    features: [
      "Building from Scratch",
      "Renovation",
      "Painting",
      "Tiling",
      "Roofing",
      "Plumbing",
      "Electrical",
      "Flooring",
      "Carpentry",
      "Concrete Work",
      "Kitchen & Bathroom Remodeling",
      "Outdoor Landscaping"
    ]
  },
  {
    id: 2,
    title: "Prefab Steel Buildings",
    description: "Design, source, ship, and construct prefabricated steel buildings to your exact specifications. Fast, durable, and cost-effective solutions.",
    icon: "warehouse",
    features: ["Custom Design", "Global Sourcing", "Shipping & Logistics", "Professional Installation"]
  },
  {
    id: 3,
    title: "Generator Solutions",
    description: "Complete generator services including sourcing, shipping, and delivery of all sizes directly to your doorstep. Reliable power solutions.",
    icon: "zap",
    features: ["All Sizes Available", "Doorstep Delivery", "Installation Support", "Maintenance Services"]
  },
  {
    id: 4,
    title: "Tools & Equipment",
    description: "Source hard-to-find tools and equipment at competitive prices. Quality construction supplies delivered when you need them.",
    icon: "wrench",
    features: ["Wide Selection", "Affordable Pricing", "Fast Sourcing", "Quality Assured"]
  }
];

export const generators = [
  { 
    id: 1, 
    name: "24KW/30KVA Generator", 
    power: "Prime: 24KW/30KVA", 
    standby: "Standby: 26.4KW/33KVA",
    description: "Stamford alternator, Cummins engine, silent type with ATS", 
    price: "USD $19,999.00",
    priceValue: 19999,
    features: ["Cummins Engine", "Stamford Alternator", "Silent Enclosure", "ATS Included"]
  },
  { 
    id: 2, 
    name: "40KW/50KVA Generator", 
    power: "Prime: 40KW/50KVA", 
    standby: "Standby: 44KW/55KVA",
    description: "Stamford alternator, Cummins engine, silent type with ATS", 
    price: "USD $22,999.00",
    priceValue: 22999,
    features: ["Cummins Engine", "Stamford Alternator", "Silent Enclosure", "ATS Included"]
  },
  { 
    id: 3, 
    name: "50KW/62.5KVA Generator", 
    power: "Prime: 50KW/62.5KVA", 
    standby: "Standby: 55KW/68.75KVA",
    description: "Stamford alternator, Cummins engine, silent type with ATS", 
    price: "USD $26,999.00",
    priceValue: 26999,
    features: ["Cummins Engine", "Stamford Alternator", "Silent Enclosure", "ATS Included"]
  }
];

export const generatorFeatures = [
  "New & Original",
  "50Hz, 220V, 1 Phase, 1500rpm",
  "Silent Enclosure 60-80dB",
  "Automatic Transfer Switch (ATS)",
  "Base Fuel Tank (130L/190L)",
  "Stamford Alternator",
  "Cummins 4BA3.9-G2 Diesel Engine",
  "Pure Copper Battery Cables",
  "Silencer & Radiator",
  "Start-up Battery + Charger",
  "Oil & Weather-resistant Tubing"
];

export const deliveryInfo = {
  timeline: [
    { step: "To Shipper", days: "20 Working Days" },
    { step: "To Jamaica", days: "35 Days" },
    { step: "To Your Doorstep", days: "10 Days" }
  ],
  payment: {
    deposit: "50% Deposit Required",
    balance: "Balance is paid prior to goods delivery to shipper",
    warranty: "Warranty: Conditions Apply"
  },
  note: "Price Validity: May Change With Notice. All prices include delivery to your doorstep in Jamaica."
};

export const allGeneratorSizes = [
  "10KW/12.5KVA",
  "15KW/18.75KVA",
  "20KW/25KVA",
  "24KW/30KVA",
  "30KW/37.5KVA",
  "40KW/50KVA",
  "50KW/62.5KVA",
  "60KW/75KVA",
  "80KW/100KVA",
  "100KW/125KVA",
  "120KW/150KVA",
  "150KW/187.5KVA",
  "200KW/250KVA",
  "250KW/312.5KVA",
  "300KW/375KVA",
  "400KW/500KVA",
  "500KW/625KVA",
  "600KW/750KVA",
  "800KW/1000KVA",
  "1000KW/1250KVA and above"
];

export const generatorTypes = [
  "Open Type Generators",
  "Silent/Soundproof Type Generators",
  "Mobile/Trailer Mounted Generators",
  "Container Type Generators",
  "Marine Generators",
  "Gas Generators (Natural Gas/LPG)",
  "Diesel Generators",
  "Petrol/Gasoline Generators"
];

export const toolsEquipment = [
  {
    id: 1,
    category: "Hand Tools",
    subcategories: [
      {
        name: "General Hand Tools",
        items: ["Claw hammer", "Framing hammer", "Sledgehammer", "Rubber mallet", "Screwdrivers (flat, Phillips, star)", "Allen key set", "Adjustable wrench", "Combination wrench set", "Socket set", "Pliers (needle-nose, groove joint, locking, cutting)", "Bolt cutters", "Crowbar / pry bar", "Tin snips", "Utility knife", "Hand saw", "Hacksaw", "Chisels", "Files & rasps", "C-clamps / bar clamps", "Bench vise"]
      },
      {
        name: "Earthwork & Site Tools",
        items: ["Shovels (round & square)", "Pickaxe", "Mattock", "Rakes", "Wheelbarrow", "Digging bar"]
      }
    ]
  },
  {
    id: 2,
    category: "Measuring, Layout & Survey Tools",
    items: ["Tape measures (16ft–100ft)", "Chalk line", "Spirit level", "Laser level", "Plumb bob", "Framing square", "Speed square", "Surveyor's tripod & leveling instrument", "Marking gauge", "Measuring wheel"]
  },
  {
    id: 3,
    category: "Power Tools (Electric & Battery)",
    subcategories: [
      {
        name: "Cutting Tools",
        items: ["Circular saw", "Miter saw", "Reciprocating saw", "Table saw", "Portable band saw", "Angle grinder", "Cut-off saw (gas or electric)"]
      },
      {
        name: "Drilling & Fastening",
        items: ["Cordless drill", "Hammer drill", "Rotary hammer", "Impact driver", "Impact wrench", "Screw gun", "Pneumatic nail gun"]
      },
      {
        name: "Finishing Tools",
        items: ["Orbital sander", "Belt sander", "Concrete grinder", "Power planer"]
      }
    ]
  },
  {
    id: 4,
    category: "Concrete & Masonry Equipment",
    subcategories: [
      {
        name: "Concrete Tools",
        items: ["Concrete mixer", "Poker/vibrator", "Power trowel", "Screed boards", "Hand trowels", "Bull float", "Edgers & groovers", "Concrete buckets"]
      },
      {
        name: "Rebar & Formwork Tools",
        items: ["Rebar cutter", "Rebar bender", "Rebar tying tools (manual & automatic)", "Wire reels", "Formwork clamps", "Shuttering materials"]
      },
      {
        name: "Masonry Tools",
        items: ["Block trowel", "Brick trowel", "Mason's hammer", "Mason line", "Mortar board", "Line blocks & corner posts"]
      }
    ]
  },
  {
    id: 5,
    category: "Prefabricated Steel Building Tools",
    subcategories: [
      {
        name: "Steel Cutting & Fabrication",
        items: ["Oxy-acetylene torch", "Plasma cutter", "Metal chop saw", "Heavy-duty angle grinder", "Magnetic drill"]
      },
      {
        name: "Welding Tools",
        items: ["Arc welding machine", "MIG welder", "TIG welder", "Welding leads & clamps", "Welding helmets & gloves", "Welding curtains"]
      },
      {
        name: "Steel Fastening & Assembly",
        items: ["High-torque impact wrench", "Torque wrench set", "Heavy-duty ratchet spanners", "Rivet guns", "Steel punches", "Bolt tension tools"]
      },
      {
        name: "Rigging, Hoisting & Lifting",
        items: ["Chain hoists", "Lever hoists", "Wire rope slings", "Nylon slings", "Shackles & hooks", "Spreader bars", "Beam clamps"]
      }
    ]
  },
  {
    id: 6,
    category: "Earthworks & Heavy Equipment",
    items: ["Mini excavator", "Excavator", "Backhoe loader", "Bulldozer", "Skid steer / Bobcat", "Trencher", "Dump truck", "Roller compactors", "Plate compactor", "Jumping jack compactor", "Water truck"]
  },
  {
    id: 7,
    category: "Electrical, Plumbing & HVAC Tools",
    subcategories: [
      {
        name: "Electrical",
        items: ["Multimeter", "Voltage tester", "Wire strippers", "Crimping tools", "Cable cutters", "Conduit bender", "Fish tape"]
      },
      {
        name: "Plumbing",
        items: ["Pipe wrench", "Basin wrench", "PVC & copper pipe cutters", "Threading machine", "PEX crimp tools", "Plungers & snakes"]
      },
      {
        name: "HVAC",
        items: ["Refrigerant gauges", "Vacuum pump", "Manifold set", "Flaring tools", "Fin comb"]
      }
    ]
  },
  {
    id: 8,
    category: "Jobsite Support Equipment",
    items: ["Generators", "Portable lighting", "Extension cords", "Air compressors", "Scaffolding systems", "Ladders (A-frame, extension)", "Workbenches", "Tool storage boxes", "Portable toilets", "First aid kits"]
  },
  {
    id: 9,
    category: "Safety Equipment & PPE",
    items: ["Hard hats", "Steel-toe boots", "Safety goggles", "High-visibility vests", "Gloves (general, cut-resistant, welding)", "Respirators & dust masks", "Fall protection harnesses", "Lifelines & anchors", "Ear protection", "Fire extinguishers", "Barricade tape & cones"]
  }
];

export const projects = [
  {
    id: 1,
    title: "Hotel Renovation",
    category: "Construction",
    location: "Montego Bay, Jamaica",
    description: "Complete hotel renovation and modernization"
  },
  {
    id: 2,
    title: "Prefab Warehouse Facility",
    category: "Prefab Steel",
    location: "Kingston, Jamaica",
    description: "15,000 sq ft steel warehouse"
  },
  {
    id: 3,
    title: "Truck Service Building",
    category: "Prefab Steel",
    location: "Kingston, Jamaica",
    description: "Commercial truck maintenance and service facility"
  },
  {
    id: 4,
    title: "Industrial Generator Installation",
    category: "Generators",
    location: "Kingston, Jamaica",
    description: "Industrial and Residential backup power system"
  },
  {
    id: 5,
    title: "Residential Apartment Complex",
    category: "Construction",
    location: "Kingston, Jamaica",
    description: "Multi-unit residential apartment building"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Michael Thompson",
    company: "Thompson Manufacturing Ltd.",
    text: "QNC delivered our prefab warehouse on time and within budget. Their attention to detail and professionalism exceeded our expectations.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Williams",
    company: "Williams Retail Group",
    text: "The generator installation was seamless. QNC handled everything from sourcing to installation. Highly recommended!",
    rating: 5
  },
  {
    id: 3,
    name: "David Chen",
    company: "Chen Construction Co.",
    text: "Been working with QNC for years. They consistently deliver quality tools and equipment at competitive prices.",
    rating: 5
  }
];

export const companyInfo = {
  name: "QNC Co. Limited",
  tagline: "Building Into The Future",
  alternativeTagline: "Building Strength. Shaping Jamaica.",
  address: "141B Constant Spring Rd, Kingston, Jamaica",
  phone: "876-479-7139 / 876-784-7936",
  email: "qncconstructions@gmail.com",
  hours: "Mon-Sat: 8:00 AM - 6:00 PM, Sun: 9:00 AM - 3:00 PM"
};

export const missionVisionValues = {
  mission: "To deliver reliable, innovative, and purpose-built construction solutions that strengthen Jamaica's infrastructure and support community development. We are committed to quality workmanship, timely execution, and responsive service—ensuring every project meets the highest standards of safety, durability, and value for our clients.",
  vision: "To become Jamaica's leading construction partner—recognized for excellence, trusted for integrity, and sought after for our ability to build resilient structures that support national growth, modernization, and recovery.",
  coreValues: [
    {
      id: 1,
      title: "Integrity",
      description: "We operate with honesty, transparency, and respect in every interaction, ensuring our clients' confidence and long-term trust.",
      icon: "shield"
    },
    {
      id: 2,
      title: "Quality",
      description: "We deliver workmanship that meets or exceeds industry standards, supported by skilled teams and strong project discipline.",
      icon: "award"
    },
    {
      id: 3,
      title: "Safety",
      description: "We prioritize safe job sites, safe practices, and structures built for resilience—protecting our teams, clients, and communities.",
      icon: "shield-check"
    },
    {
      id: 4,
      title: "Reliability",
      description: "We complete projects on time and within scope, backed by consistent performance and dependable service delivery.",
      icon: "clock"
    },
    {
      id: 5,
      title: "Innovation",
      description: "We embrace modern construction technologies, efficient methods, and forward-thinking solutions to meet Jamaica's growing infrastructure needs.",
      icon: "lightbulb"
    },
    {
      id: 6,
      title: "Community Commitment",
      description: "We recognize our role in national development and actively contribute to rebuilding, recovery, and improving Jamaica's built environment.",
      icon: "heart"
    }
  ]
};